import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    variant?: 'danger' | 'primary';
    loading?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    variant = 'danger',
    loading = false
}) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-6 text-center">
                <div className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center ${variant === 'danger' ? 'bg-red-50 text-red-500' : 'bg-blue-50 text-blue-500'}`}>
                    {variant === 'danger' ? (
                        <span className="text-3xl">⚠️</span>
                    ) : (
                        <span className="text-3xl">ℹ️</span>
                    )}
                </div>

                <p className="text-gray-600 font-medium whitespace-pre-wrap">{message}</p>

                <div className="flex items-center gap-3 pt-2">
                    <Button
                        onClick={onConfirm}
                        disabled={loading}
                        className={`flex-1 py-3 rounded-xl font-bold shadow-lg transition-all ${variant === 'danger'
                                ? 'bg-red-500 text-white shadow-red-500/20 hover:bg-red-600'
                                : 'bg-primary text-white shadow-primary/20 hover:bg-primary/90'
                            }`}
                    >
                        {loading && <span className="w-5 h-5 animate-spin">⌛</span>}
                        {confirmText || t('common.confirm')}
                    </Button>
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={loading}
                        className="flex-1 px-6 py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-100 transition-all border border-gray-100"
                    >
                        {cancelText || t('common.cancel') || 'إلغاء'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
